module.exports = __webpack_public_path__ + "img/mit.e194860b.png";